import { useAuth } from '../contexts/AuthContext';
import '../style/Header.css';

const Header = () => {
  const { user, logout } = useAuth();

  return (
    <header className="header">
      <div className="header-left">
        <img 
          src="https://mybrandz.com.au/wp-content/uploads/2025/04/MyBrandz-logo-2024_med-e1743462702599.png" 
          alt="TD Logo" 
          className="header-logo"
        />
        <h1>Document Dashboard</h1>
      </div>
      <div className="header-right">
        <span className="user-name">Welcome, {user?.username}</span>
        <button className="logout-button" onClick={() => logout()}>
          Logout
        </button>
      </div>
    </header>
  );
};

export default Header;
